import type { ReactElement } from "react";
import { Link } from "react-router";

import { usePageMeta } from "../../app/use-page-meta.js";
import { FormSummary, TextField } from "../../forms/fields.js";
import { useApiForm } from "../../forms/use-api-form.js";
import { changePasswordRules } from "../../forms/view-model-rules.js";

import { accountApi, accountUrls } from "./urls.js";
import { accountOf, useSignedInOnly } from "./use-signed-in-only.js";

/** 最後の確認はブラウザの確認ダイアログで行う（重要な操作は最後にダイアログで確かめる。2026-10-10 に利用者が決めた）。 */
export const changePasswordDialog = (email: string | undefined): string =>
    `${accountOf(email)}のパスワードを変更します。次回から新しいパスワードでログインします。よろしいですか？`;

/**
 * ログイン中のパスワード変更。<b>今のパスワードを確かめてから変える。</b>
 * 変えた後はアカウント設定へ戻り、通知は API の notice が出す。
 */
export function ChangePasswordPage(): ReactElement {
    usePageMeta("パスワードの変更");
    const email = useSignedInOnly();
    const form = useApiForm(accountApi.changePassword, changePasswordRules, changePasswordDialog(email));

    return (
        <div className="page max-w-md">
            <div className="panel">
                <h1 className="page-title">パスワードの変更</h1>
                <p className="page-lead">現在のパスワードを確認したうえで変更します。</p>

                <form method="post" noValidate onSubmit={form.onSubmit} onChange={form.onChange} onBlur={form.onBlur}>
                    <FormSummary messages={form.summary} />

                    <TextField
                        label="現在のパスワード" name="OldPassword" type="password" required
                        autoComplete="current-password" autoFocus
                        error={form.fieldError("OldPassword")}
                    />
                    <TextField
                        label="新しいパスワード" name="NewPassword" type="password" required
                        autoComplete="new-password"
                        help="10 文字以上で入力してください。"
                        error={form.fieldError("NewPassword")}
                    />
                    <TextField
                        label="新しいパスワードの確認入力" name="ConfirmPassword" type="password"
                        autoComplete="new-password"
                        wrapperClassName="mb-7"
                        error={form.fieldError("ConfirmPassword")}
                    />

                    <div className="flex gap-3">
                        <Link to={accountUrls.settings} className="btn-secondary">キャンセル</Link>
                        <button type="submit" className="btn-primary grow" disabled={form.busy}>変更する</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
